import { render } from "./TestInterview.vue?vue&type=template&id=983e9b70&scoped=true"
import script from "./TestInterview.vue?vue&type=script&lang=js"
export * from "./TestInterview.vue?vue&type=script&lang=js"

import "./TestInterview.vue?vue&type=style&index=0&id=983e9b70&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-983e9b70"]])

export default __exports__